import { PieChartResultResponse } from '@business/entities/dashboard';
import { Formatter } from '@core/utils/formatter';
import React, { memo, useMemo } from 'react';
import { Card, CardTitle } from 'reactstrap';
import { WidgetProps } from '../types';
import { WidgetIcons } from '../BaseWidget';
import ReactEcharts from 'echarts-for-react';
import { R } from '@core/utils/r';
import { Theme } from '@core/utils/css';
export const PieChartWidget = memo((props: WidgetProps<PieChartResultResponse>) => {
  const { settings, result, isPreview = false } = props;

  const series = result ? result?.series : [44, 55, 41, 17, 15];

  const data = useMemo(() => {
    if (!result || !R.get(result, 'labels')) {
      if (isPreview) {
        return [
          { value: 1048, name: 'Search Engine' },
          { value: 735, name: 'Direct' },
          { value: 580, name: 'Email' },
          { value: 484, name: 'Union Ads' },
          { value: 300, name: 'Video Ads' },
        ];
      }
      return [];
    }
    return result.labels.map((label, index) => {
      let newLabel = label;
      if (R.isString(label)) {
        try {
          const result = JSON.parse(label);
          if (R.isArray(result)) {
            newLabel = result.join(', ');
          }
        } catch (e) {
          newLabel = label;
        }
      }
      return {
        value: result.series[index],
        name: newLabel,
      };
    });
  }, [isPreview, result]);

  const options = {
    tooltip: {
      trigger: 'item',
      formatter: (data: any) =>
        data.name + ': ' + (result?.label ? Formatter.formatCurrency(data.value) : Formatter.formatInteger(data.value)) + ' (' + data.percent + '%)',
    },
    series: [
      {
        label: {
          formatter: (data: any) => `${data.name} (${data.percent}%)`,
          color: Theme.isDark ? '#FFF' : '#000',
        },
        type: 'pie',
        radius: '60%',
        data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  return (
    <Card className="p-4" style={{ marginBottom: 0, flex: 1 }}>
      <CardTitle className="d-flex align-items-center flex-row">
        {settings.title || 'Pie Chart'} <WidgetIcons {...props} />
      </CardTitle>
      <div className="e-chart d-flex" style={{ flexGrow: 1, height: '100%' }}>
        <ReactEcharts style={{ height: '100%', width: '100%' }} option={options} />
      </div>
      {/* <div id="pie-chart" className="e-chart">
        <ReactApexChart options={options} series={series} type="pie" height={settings.grid.h * 100 - 50} />
      </div> */}
    </Card>
  );
});
